<template>
  <div>
    <div class="index-module_articleWrap_2Zphx">
        <div class="zhemo">李录：价值投资的知行合一</div>
      
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >导读：价值投资为什么知易行难？或许是因为我们许多人，表面上知道一些皮毛，却未必真正理解价值投资的内核。价值投资也是一种价值观，一种生活方式。</span
          >
        </p>
        <!--20--><!--21--><!--22--><!--23--><!--24--><!--25-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >本文是根据李录先生2019年11月29日于北京大学光华管理学院价值投资课上所作演讲整理而成，建议与2015年11月北京大学光华管理学院价值投资课上所作演讲《价值投资在中国的展望》一起阅读。</span
          >
        </p>
        <!--26--><!--27--><!--28--><!--29--><!--30--><!--31-->
      </div>
      <div class="index-module_mediaWrap_213jB">
        <!--32--><!--33-->
        
        <!--34--><!--37--><!--38--><!--39-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">一、价值投资的理论与实践</span></p>
        <!--40--><!--41--><!--42--><!--43--><!--44--><!--45-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >很高兴五年后有机会重新来到北大光华管理学院的这门价值投资课上与大家分享。今天是美国的感恩节，借此机会我要感谢光华管理学院的姜国华教授和喜马拉雅资本的常劲先生，以及在座的各位同学和价值投资的追求者、支持者，感谢各位这些年来对价值投资在中国的实践的传播与支持。</span
          >
        </p>
        <!--46--><!--47--><!--48--><!--49--><!--50--><!--51-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >另外，五年来，我一直对自己在此讲的第一课有点遗憾。那堂课中我们主要讨论了价值投资的基本理论，尤其是否适合中国，但是对价值投资的具体实践讲得不多。事实上，价值投资主要是一门实践的学问，所以今天我主要讲价值投资中的实践问题。我想先讲讲自己理解价值投资实践的框架，然后留出时间给大家提问。</span
          >
        </p>
        <!--52--><!--53--><!--54--><!--55--><!--56--><!--57-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >价值投资的基本概念只有四个。第一，股票是对公司的部分所有权，而不仅仅是可以买卖的一张纸。第二，安全边际。投资的本质是对未来进行预测，而我们对未来无法精确预测，只能得到一个概率，所以需要预留安全边际。第三，市场先生。市场的存在是为了你来服务的，不是来指导你的。第四，能力圈。投资人需要通过长期的学习建立一个属于自己的能力圈，然后在能力圈范围之内去做投资。这就是价值投资的基本思维框架，逻辑简单、清晰，理解起来并不难，而且在投资实践中，价值投资是我所了解的唯一能够为投资人带来风险加权后长期优异回报的一种投资方法。也因此，很多人对价值投资都有了解，尤其是因为价值投资界最出名的实践者巴菲特先生——他过去60年来的成功在全世界引起了现象级的关注。但是据实证研究，市场参与者中可能只有不到5%的人是真正的价值投资者。为什么明白价值投资的人很多，实际从事价值投资实践的人却这么少？今天我主要讲讲在价值投资的实践中为什么知易行难，难在何处？为什么人们在实践中会遇到种种问题，遇到问题后又容易被其它方法吸引过去？</span
          >
        </p>
        <!--58--><!--59--><!--60--><!--61--><!--62--><!--63-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">让我们逐个分析一下这四个概念。</span></p>
        <!--64--><!--65--><!--66--><!--67--><!--68--><!--69-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >价值投资四个概念中的第一个——股票是对公司的部分所有权，实际是一个制度性的观念。如果股权可以代表公司的部分所有权，在一个制度下，如果私人财产权能得到真正的保护，那么对私人财产的使用也就能得到保护，私人财产权也就能够自由交换。如果财产权不能自由交换，也很难成为真正的权利。例如现金就是一个财产权，因为我们可以随时使用它，把它变成我们想要的东西。所以对股权交换的保护是一个社会是否保护私人财产的重要标志。能不能做到这点是由社会本身决定的，和投资人的因素没有关系。一个社会只要允许这样的制度存在，就会有价值投资的存在。就目前来看，这样的制度在我们的社会中确实是存在的，股权交换是被允许的，因此股票是对公司的部分所有权这点是成立的。</span
          >
        </p>
        <!--70--><!--71--><!--72--><!--73--><!--74--><!--75-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第二个——安全边际，实际是一个方法问题，概念上没有特别大的歧义。付出的是价格，得到的是价值。因为对价值不是很确定，所以要以尽量低的价格购入，这一点相信大家都认同。那么这样看来，价值投资在实践中最主要的困难可能来自另外两个概念，一是市场先生的假设，二是能力圈的建设。</span
          >
        </p>
        <!--76--><!--77--><!--78--><!--79--><!--80--><!--81-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >对于市场先生的假设，我们先回顾一下最早本杰明·格雷厄姆教授是怎么描述他的——他说你可以把股票市场想象成是一个精力特别旺盛、不太善于判断、也不太聪明但也不坏的人，他每天早上起来第一件事就是给你吆喝各种各样的价格，不管你感不感兴趣，他都不停地吆喝。但是这位市场先生的情绪变化无常，有时候他对未来特别乐观，价格就叫得非常高；有时候他特别抑郁，价格就会喊得很低。绝大部分时间你可以对他完全忽略不计，但是当他变得神经质的时候，或者极其亢奋，或者极其抑郁，你就可以利用他的过度情绪去买和卖。</span
          >
        </p>
        <!--82--><!--83--><!--84--><!--85--><!--86--><!--87-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是你会发现自己面临一个很大的问题。在学校里，当你读到市场先生的概念时，你会觉得很有道理，然而一旦进入到市场开始工作的时候，你会发现跟你做交易的对手都是真实存在的人。这些人看起来学历很高、钱比你多、权力比你大、经验也比你丰富，个个都是“高大上”、很成功，有些甚至是你的上级，你觉得他们怎么看也不像格雷厄姆形容的那位市场先生。在你和他交手的过程中，短期来看你还常常是错误的那方。一段时间后，你不断被领导训话、被“错误”挫败，就开始感觉好像自己才是那位傻傻的市场先生，别人都比你厉害，开始对自己所有的想法都产生怀疑了。这是我们在价值投资的实践中会遇到的第一个困难和障碍。</span
          >
        </p>
        <!--88--><!--89--><!--90--><!--91--><!--92--><!--93-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第二个困难是我们对自己的能力圈的界定。能力圈的边界到底在哪里？怎样才能显示我真地懂了？当市场变化剧烈的时候，我买的股票全在亏，而别人的都在涨，我怎么判断自己是正确的，别人是错误的呢？</span
          >
        </p>
        <!--94--><!--95--><!--96--><!--97--><!--98--><!--99-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >今天我主要针对市场先生和能力圈这两个困难来讲四个问题。</span
          >
        </p>
        <!--100--><!--101--><!--102--><!--103--><!--104--><!--105-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第一，股市——关于股市里面的投资和投机的问题。第二，能力圈是什么？如何建立？第三，投资人的品性——无论是沃伦还是查理都曾讲过投资人最重要的一个叫“temperament”的概念，这个词不太好翻译成中文，我给它定义叫“品性”。品性中有一些是与生俱来的，也有一些是后天培养的。价值投资人具有哪些品性、修养？这些品性、修养应该如何培养？第四，普通的投资人如果不想做专业的投资人，应该怎么去保护和增加自己的财富？希望这四个问题能涵盖到价值投资实践的大部分情况。</span
          >
        </p>
        <!--106--><!--107--><!--108--><!--109--><!--110--><!--111-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">二、股市：投资与投机的结合体</span></p>
        <!--112--><!--113--><!--114--><!--115--><!--116--><!--117-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们在股票市场中投资，首先必须得面对股市。股市到底是什么？股市里面的人是哪些人？他们的行为有哪些类型？价值投资人在其中处于什么样的位置？</span
          >
        </p>
        <!--118--><!--119--><!--120--><!--121--><!--122--><!--123-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们先回溯一下股市的历史。现代的股市大概出现在400年前，其历史不算太长，在此之前商业机会不多，不需要股市的存在。那个时期发生的最大一件事是500年前新大陆的发现，这为整个欧洲带来了此后一两百年经济上的高速发展。伴随着殖民时代，出现了一些所谓的现代公司。公司这个概念是怎么来的呢？因为当时的殖民商业活动和远洋贸易需要大量资金且风险很高，最早的殖民商业活动都是由最有钱的欧洲各国的国王支持和资助的，但很快国王的钱也不够用了，必须去和贵族等一起合组公司，于是就出现了最早的现代股份公司，用股权的方式把公司所有权分散开来。因为这些公司的发展速度比较快，需要的钱很多，国王和贵族的钱也不够用了，便想办法让普通人的储蓄也能够发挥作用，于是产生了把股权进一步切分的想法。但问题是，一般的老百姓很难对股权定价。他们不太懂这些公司到底怎么赚钱，所以想到的办法是把股权分得尽可能小，只要投很少的钱就可以加入，而且可以随时把股权卖出去。这个设计迎合了人性中比较贪婪、懒惰、喜欢走捷径的心理。人类从本性而言都想走捷径，不劳而获，通过付出最少方式获得最多的利益，并为此甘愿冒险，也就是所谓的赌性，这也是为什么赌博在历史上几乎所有时期一直都存在的原因。</span
          >
        </p>
        <!--124--><!--125--><!--126--><!--127--><!--128--><!--129-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >股市最早的设计迎合了人性中赌性的部分，所以股市一发展起来就获得了巨大的成功。当时荷兰最重要的两家公司，东印度公司和西印度公司，尤其是东印度公司正处在一个长期发展的阶段。股权融资的钱被迅速地用于公司的经营发展，为投资人产生更多的利润回报，于是形成了一个正向的循环。越来越多的人被吸引到股市中去，并且可以随时买卖股票，这就形成了另外一个买卖的动机，买卖东印度公司股票的人不仅是在猜测东印度公司未来的业绩，更多是在猜测其他人买卖这支股票时的行为。投机行为使早期股市大受欢迎，越来越多的公司因此发展起来了。</span
          >
        </p>
        <!--130--><!--131--><!--132--><!--133--><!--134--><!--135-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但股市还有另一个非常奇妙的功用——正向循环的机制。随着越来越多人的参与，越来越多的公司被吸引进入股市，这些公司如果处在一个长期上升的经济中，通过股市融资就能够扩大生产规模，创造更多产品、更多的价值，让人们获得更多的财富，人们有了更多财富就会产生更多的消费，这就形成了经济中正向的循环机制。虽然股市在刚开始的时候，其设计机制利用了人性中赌性的成分，但当参与的人和公司到达一定数量时，如果经济本身能够不断地产生这样的公司，这个机制就能持续下去。</span
          >
        </p>
        <!--136--><!--137--><!--138--><!--139--><!--140--><!--141-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >恰好也在400年前，另外一种制度开始慢慢诞生，这就是现代资本主义制度，亦即现代市场经济制度。此时科学技术本身已经开始发生革命性的变化，持续数百年，一直到今天还在进行。科技革命和市场经济的结合，产生了一个人类历史上从未发生过的现象——经济开始呈现出持续的、累进的增长，连续增长了大约三、四百年，把人类文明带入了一个前所未有的崭新阶段。累进（复合增长）是一个很可怕的概念，绝大部分人大概不知道累进的力量有多大，因为这个现象在人类历史上从来没有发生过。假如一个公司的利润以每年百分之六、七的速度增长，连续增长200多年，大概会增长多少倍？虽然每年百分之六、七的回报率看起来不是很高，但200多年后可以增长100多万倍。这就是累进回报的力量！</span
          >
        </p>
        <!--142--><!--143--><!--144--><!--145--><!--146--><!--147-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这样的回报会吸引越来越多的股民进入股市，越来越多的股民进入股市，就会越吸引越来越多的公司上市。这是股市能把社会的全部要素都调动起来的一个很奇妙的功能。股市最早的设计初衷未必是这样，但是结果确是如此。所以股市中从一开始基本上就有两类人，一类是投资的，另一类是投机的。投资者预测公司本身未来的表现，而投机者则是预测股市中其他参与者在短期之内的行为。</span
          >
        </p>
        <!--148--><!--149--><!--150--><!--151--><!--152--><!--153-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这两类人有何区别？投资跟投机最大区别在哪？这两种行为的结果有何区别？</span
          >
        </p>
        <!--154--><!--155--><!--156--><!--157--><!--158--><!--159-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >对投资者而言，如果投资的公司遇到一个可以累进、持续增长的经济，它的利润和投资回报会持续增长。而对投机者而言，如果只是猜测他人在短期之内的买卖行为，到最后只可能有一种结果：赢和输必须相等，也就是零和的结果——这个市场中所有的投机者买卖股票所获得的利润和亏损加在一起，其净值一定为零。这就是投机和投资最大的区别。当然我不否认其中有些人可能赢的概率高一些、时间长一些，而有些人可能一直在做韭菜、一直没翻身。但是总的来说，只要给足够的时间，全部投机者无论赚钱还是亏钱，加在一起的结果是零，因为这些投机的股市参与者短期内的行为不会对经济、对公司本身利润的成长产生任何影响。有的人可能说我是“80%的投资，20%的投机”，是混合型。这类参与者，他70%、80%的投资人那方面的工作如果做得对，甚至他只投了指数，其回报也会因为现代经济累进增长的特点而持续增长，但他投机的部分一定会纳入到所有投机者行为的总和中，最终的结果是一样的——全部归零。</span
          >
        </p>
        <!--160--><!--161--><!--162--><!--163--><!--164--><!--165-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >知道这个结果后，你是选择去做一个投资者，还是一个投机者？当然这是个人的选择，没有好恶，唯一的不同是它对社会的影响。投资者的确会让社会的所有要素进入一种正向循环，帮助社会进入到现代化。所谓现代化，其实就是一种经济开始进入到复利增长的状态。关于现代化，有兴趣的同学可参阅我之前写的长篇文章《李录谈现代化十六讲》。</span
          >
        </p>
        <!--166--><!--167--><!--168--><!--169--><!--170--><!--171-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >相对而言，股市投机的部分跟赌场非常接近。从社会福祉的角度讲，我们不希望这个赌场太大。如果没有赌性、投机的部分，市场也无法存在。但真正能让股市长期发展下去的参与者是投资者。我们可以把投机的部分当做
            necessary
            evil（必要之恶）看待，这一点是去不掉的，也是人性的一部分。我们无法否认人性中赌性、投机的成分，但我们不能让这个部分太大。无论何时、何事，如果投机的成分太大，社会必然会受到伤害。我们刚刚从2008-2009年全球金融危机里走出来，对这种伤害还是记忆犹新的。所以当你明白了归零的道理，你的确可以把那些投机者当作市场先生。</span
          >
        </p>
        <!--172--><!--173--><!--174--><!--175--><!--176--><!--177-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >有些投机者可能的确在股市中获了利，在一段时间内投机套利很成功，比你有钱、有地位，但是你骨子里明白，他所有的行为总和最终是归零的。如果你的价值观是希望对社会有所贡献，那你毫无必要对他表现出那么多的尊重，哪怕他各方面看起来都比你强。这是一个价值观的问题。但你如果不明白这个道理，或者不认同这样的价值观，就会总觉得自己错失了机会，其他人懂得比你多、做得比你对。</span
          >
        </p>
        <!--178--><!--179--><!--180--><!--181--><!--182--><!--183-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >既然投机活动长期加总为零，不产生任何真正效益，那么又为什么投机者能够长期存在呢？这就回到资产管理行业的一个特点。资产管理行业虽然是服务行业，但是存在着严重的信息不对称，投资跟投机的区别很难被鉴别。所有的投机者都有很多理论，现在讲K线已经是比较“低级”的了，最新的理论讲AI（人工智能），但本质上两者都一样。当他们用这些理论试图说服你的时候，总能让绝大部分人云里雾里。关于投资和投机的道理其实很简单，但我没有看到任何正式的教科书里谈到这个根本的问题。为什么没人谈这个问题呢？大多数人要不是没想清楚，就是因为只有这样才有利可图。不谈这个问题的好处在哪？可以收税啊。它实际上收的是一种无知税，或者叫信息剥削税。资管行业存在的一个很大的根基，就是因为无知税的存在。大批的人能在这个行业里存活下来，主要是靠信息剥削。不管将来的结果如何，我只要能够在短暂的一段时间里，暂时表现我在盈利，马上去做各种各样的广告，让全世界都知道、都来买，不管将来结果怎么样，我先收1%、2%，反正拿到钱、收了税之后，不管结果怎样我先稳赚。这个行业确实如此，所有的收费标准都一样。如果这种收费机制特别有道理的话，是不是那些真正能够带来回报的投资经理应该收得多一些？而其他人应该少一些？但实际情况不是这样，大家收费都一样。因为谁也说不清楚哪个投资经理更优秀，只有过了很长的时间才能看到孰优孰劣。而且每个人的投资理论都非常复杂，你很难立刻判断说他一定不行。</span
          >
        </p>
        <!--184--><!--185--><!--186--><!--187--><!--188--><!--189-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以搞清楚投机者和投资者的区别很重要，搞清楚市场先生在哪里也很重要。你要是不愿意交信息剥削税，或者你不愿意靠收信息剥削税去生活，那你可能就要忍耐、坚持。如果你相信合理回报，想对社会有所贡献，那从一开始你就要愿意做一个投资者，如果做不了的话，也要努力不要向一个投机者交信息剥削税。这就是为什么理解清楚市场先生的概念很重要。因为你如果不想清楚这个概念，无论在学校里曾经是怎么想的，只要一开始工作，别人给你一讲别的理论，你脑子就乱了，立刻就觉得好像别人说的很对，自己原来的想法不太对，被市场先生这个概念给误导了。所以大家只要记住投机归零的概念，就会明白为什么这些投机者没有长期的业绩，靠投机做不出长期业绩，也做不大。有一些短期的做得比较好的，其实多多少少是靠legalized
            front
            running（合法的抢先交易）。做老鼠仓可以一直赚钱，但这是非法的。如果你想出一种AI的办法能够猜测大家都要买卖什么股票了，例如新的指数基金，或者A股进MSCI之前，我先抢先交易一下，先建一个合法的老鼠仓，这可能也能赚些钱，是吧？但是这确实也做不大。如果能做大的话，整个社会就不合理了。所以你看到，投机的所有策略到最后都做不大，也没有长期业绩。凡是能够做大、有长期业绩的，基本上都是投资者。</span
          >
        </p>
        <!--190--><!--191--><!--192--><!--193--><!--194--><!--195-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >顺便谈谈，指数投资为什么也可以有长期回报？因为指数投资基本上就是全部投资者和投机者的总和，如果投机者最终的结果归零，那么指数投资的结果实际上就是投资者的净结果。数学上来说是不是这样？这就是为什么指数投资可以有长期回报，但这种情况只可能在其经济体已经进入现代化的社会中发生。现代化经济体能够自发地产生累进、持续的经济增长，而且在实行市场经济和股市注册制的市场，其股市指数能够比较代表经济体里所有的规模公司，在这种情况下，指数投资基本上就能反映出这个经济体大体的经济表现、商业表现。</span
          >
        </p>
        <!--196--><!--197--><!--198--><!--199--><!--200--><!--201-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">三、能力圈</span></p>
        <!--202--><!--203--><!--204--><!--205--><!--206--><!--207-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >接着我来谈下一个问题：假设我既不想去信息剥削，也不想去玩零和游戏，而是真的想正正经经做一个投资人，该怎么去做呢？</span
          >
        </p>
        <!--208--><!--209--><!--210--><!--211--><!--212--><!--213-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这就回到了能力圈这个概念。因为我们做投资者就是要去预测所投资的公司未来大体的经济表现，亦即对公司基本面的分析。要弄清楚这个公司为什么赚钱、怎么赚钱、将来会赚多少钱？遇到竞争的状态如何？它在竞争中的地位如何？我把这个过程统称为建立自己的能力圈。</span
          >
        </p>
        <!--214--><!--215--><!--216--><!--217--><!--218--><!--219-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >下面的问题是，如果我刚刚开始学习价值投资，如何开始（建立我的能力圈）呢？我怎么才能学会如何分析公司呢？各种各样的公司看了很多，但不知道从何下手。经过一段时间的研究之后，觉得对某个公司懂了一些，但是不知道懂得够不够。要等到什么时候才能买这只股票，在什么价格上才可以买？同学们问的这些问题都很具体，很多从事过这个行业的人也会有这样的疑问。那么能不能用卖方分析师给出的估值呢？从卖方的角度看，用什么价格能把股票卖出去才是他真正的考量，至于卖出的价格对不对他并没有那么关心，反正不是用他自己的钱。但如果是用自己的钱，心态可能就不一样了。所以说能力圈其实也是投资者的核心问题。</span
          >
        </p>
        <!--220--><!--221--><!--222--><!--223--><!--224--><!--225-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >怎么才能建立能力圈？对每个人而言的确不太一样，因为每个人的能力不一样，这里我可以分享一下我自己是怎么开始做的。</span
          >
        </p>
        <!--226--><!--227--><!--228--><!--229--><!--230--><!--231-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我进入这个行业其实是误打误撞。大概在二十七八年前，那时我是哥伦比亚大学的学生，刚去美国，身上就背了一大堆债务（学生贷款），不会做生意，也不知道怎么挣钱，所以天天担心如何偿还债务的问题。80年代的中国留学生都没钱，一下子去到美国，背负的债务还是美元，看起来简直是天文数字。所以我就老琢磨着怎么去赚点钱。有一天，一个同学告诉我，学校里有个人来做讲座，谈怎么赚钱，且这人特能赚钱。我一看海报上还写着提供免费午餐，我说好，那去吧。后来我去到像我们今天这样大小的一个教室，和我以前去过的提供免费午餐和讲座的教室不太一样。一般有免费午餐的教室都有个能坐二三十个人的大长桌，旁边有午饭，演讲嘉宾坐在前面。我去了就问午餐在哪？同学说那个演讲的人叫“午餐”。因为buffet（自助餐）和Buffett（巴菲特）的拼写就差一个T，而我刚开始学英语，没弄清这两个字的差别。我心想这个人既然敢叫免费午餐，肚子里肯定得有点东西，所以就坐下来听了。听着听着，我突然觉得他讲的东西比免费午餐好太多了。以前我对股市的理解，就是像《日出》（曹禺话剧）里描述那样，里面演的那些30年代在上海搞股票的人，尔虞我诈，所以我一直认为做股票的人都是坏人。但这位“免费午餐先生”怎么看都不像个坏人，而且很聪明，讲话很有趣。他讲的道理浅显易懂，不知道为什么在讲课的过程中，我突然就觉得这个事好像我可以做。因为我感觉别的事情我也做不了，但研究数字还是可以的是吧？反正从国内来的，数理化应该还可以。</span
          >
        </p>
        <!--232--><!--233--><!--234--><!--235--><!--236--><!--237-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >听完那个讲座后，我第一件事就是去图书馆找资料，研究这位老先生。越研究就越觉得这个事儿还真的是可以做。他的理论也好，实践也好，他写的那些给股东信，我基本上都能够接受。所以我就开始想办法怎么去找到有安全边际的公司，我想有安全边际的东西肯定是便宜的吧。那时我虽然对公司的生意是什么不太了解，但如果只是分析一张资产负债表，小学算数就基本够用了。所以我就开始去看《价值线》（Value
            Line），上面有几千家公司过去10年的基本财务情况。《价值线》把这些公司划分成不同的类别，其中一个类别是近期最便宜的股票，比如按照P/B是多少，P/E是多少。其实那时我对P/E还不太了解，对公司也不太了解，所以我只看资产负债表，看它的账面净资产有多少，这些净资产的价值多少，和股票市值比较。我最先看上的几个股票，实际上也不知道它们做什么生意，反正它们不亏钱。其账面上要不然就是现金，要不然就是房地产，尤其是拥有的其它公司的股票等等，而账面净资产都远高于市值，有些居然是市值的一倍还多。可能因为我还没工作，没见过那些“高大上”的华尔街人士，那时我就是确信有“市场先生”的存在。然后我就专门找了一些在纽约附近的公司去看，看看这些公司是不是真的，它们账目上的资产是不是真有，它们是不是真的在经营（虽然对它们做什么事不太清楚）。所以我开始投的几家公司其账面上的净资产都差不多是其市值的一倍。因为它们的安全边际足够高，价格足够低，所以才敢买。</span
          >
        </p>
        <!--238--><!--239--><!--240--><!--241--><!--242--><!--243-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但后来我发现了另外一件事，就是我买完以后，突然之间对公司的兴趣大增，跟以前那种理论上的兴趣完全不一样了。以前我只是学习，纸上谈兵，从来没做过投资，总觉得这些公司跟我没直接关系，也就学得不太深。而一旦我买完了一只股票后，就觉得这家公司真的是我的了。因为巴菲特先生讲的关于价值投资的这几条基本概念我都笃信不疑，尤其是他说的这第一条，就是股票是公司的所有权，我还真信。我就觉得买了它们的股票就是我的公司了，所以每天有事没事就溜达过去看一看，这公司到底在做什么呢？虽然也没太搞清它们在做什么。</span
          >
        </p>
        <!--244--><!--245--><!--246--><!--247--><!--248--><!--249-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >例如我最早投资的一家总部位于宾州的公司，当时它把其主要的有线电视业务卖给了当时最大的有线电视公司（TCI），并换成了TCI的股票，剩下的资产包括一些电信公司，这些电信公司拥有很多牌照，但收入很低，来自这些子公司的收益跟它的市值完全不成比例。我研究发现这些牌照都是花了大价钱买的，而且买的时间已经很长了，所以虽然账面价值很低，但应该值很多钱，可是也不知道估值，只知道当时仅仅它拥有的那家最大的有线电视公司（TCI）的股票价值就是这家公司市值的两倍，如果按照市净率来算的话，我认为它的股价至少得涨一倍，才跟它拥有的TCI股票价值一样。</span
          >
        </p>
        <!--250--><!--251--><!--252--><!--253--><!--254--><!--255-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >结果我买了之后不久，那家有线电视公司（TCI）的股票开始涨起来了，因为它收购了很多其它的有线电视公司。于是我突然之间对有线电视公司也开始有兴趣了，我觉得TCI也是我的，所以我就开始研究它。这类有线电视公司的业务相当于是一个地方垄断（local
            monopoly），一家公司如果在某个地区有牌照，别家公司就不能进来。有线电视用户都是提前一个月预付费用，所以公司的收益很容易预测，因此它也就能够去借很多钱，而且成本很便宜，从计算上讲其实是很简单的一个生意。TCI是一个大型上市公司，它可以用自己的股票以很便宜的价格去买一些小的非上市有线电视公司，所以它每买一家公司，其每股收益都是在增长，其股价也随着增长。这其实是一个数学概念，相对比较容易理解。TCI就是今天美国AT&amp;T
            Cable的前身，现在成为美国最大、最成功的有线电视公司。但那时大概是20多年前，它只是刚刚开始显示出与其它同类有线电视公司的不同。</span
          >
        </p>
        <!--256--><!--257--><!--258--><!--259--><!--260--><!--261-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >那时候随着TCI股票上涨，我的公司股票也开始上涨了。下面最有趣的事是，突然间那些电信牌照也变得很有用了。这时一种新的产品---手机---出现了！20多年前手机是一个新鲜事物。我的这家公司拥有的电信牌照可以用来建立一个全国性的手机无线网络，于是它聘请了当时最大电信公司的总裁去做它的CEO。这家公司本是名不见经传的一家小公司，但这件事一下子就轰动了，之后我的狗屎运就来了。这家公司的股票一下子就变的特别值钱，不仅超过了它拥有的TCI股票估值，接着又狂涨了好几倍。那时候我心里就完全没底了，因为对我来说完全没有安全边际了，所以我就卖了。当然卖完了之后股票还接着涨了很多，但当时我也弄不太清楚无线网络生意到底怎样，其实到现在也没有完全弄清楚。</span
          >
        </p>
        <!--262--><!--263--><!--264--><!--265--><!--266--><!--267-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是这个事情给我一个经验，我发现如果能有足够安全边际的时候就敢买。另外我还发现，买完了以后人的心理就真的变了。价值投资所说的股票是一种所有权，这其实也是一个心理学的概念。以前我不太懂，买完了之后才懂。光是理论上的这么讲没用，一到我买完了之后，突然发现自己成了所有者，我发现自己对所投的公司哪方面都关心。那家我买了股票的公司，记得有一次我周末去拜访，保安不让我进，结果我居然跟保安兴趣盎然地聊了一个钟头，我问说你们保安是怎么雇的，待遇如何等等。我真的把自己当老板了，对公司的方方面面都特别有兴趣，而且这些兴趣特别有助于我了解公司。其后因为它我开始研究有线电视公司，发现有线电视公司非常有意思。再后来又研究电信公司，觉得也很有意思，兴趣就起来了。我于是开始一家一家地研究另外几家类似的公司，对这个行业也了解得越来越多。买进去是因为有安全边际，但是进去之后我发现自己开始对生意本身产生了兴趣。因为这件事告诉我，公司的价值不只是资产负债表带来的，更主要是它的盈利能力（earning
            power）带来的，所以我开始对公司本身特别有兴趣。大的公司我也不太了解，所以我就找一些比较小的公司，而且最好就在我当时住的纽约附近的，这样我可以随时去查看自家的公司。跟谁聊都行，跟门口保安聊聊也行，反正是自家雇得对吧？所以我就发现人的心理（在真正买入股票以后）发生了变化，变得对公司所有的一切都特有兴趣。</span
          >
        </p>
        <!--268--><!--269--><!--270--><!--271--><!--272--><!--273-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >那个时候对我来说最有启发的还有另一间公司，这间公司拥有很多加油站，这让我对加油站也很有兴趣。那时候我住的地方附近有两家加油站，在同一个路口上，一边一个，但是我发现有一家加油站比另一家顾客多很多，哪怕是在相反道上的车也过来加油。两家加油站的价格其实一样，油也是一样的，是同一个标准。我当时觉得很奇怪，觉得既然是自家的公司，一定要看看到底怎么回事。我去看了，发现车特别多的那个加油站的拥有者是一个印度的移民，全家都住在那里。一有客人来的时候，他就一定要拿一杯水出来给客人，你不喝也会递上，然后还跟你聊聊天，如果小孩放学在的话还会来帮你清扫一下车。另一家的管理人是一个典型的白人，人也不坏。（加油站）不是他拥有的，他是拥有者雇来管理的，所以他基本上就在店里面不出来，外面怎么样他都不管。就这一点区别，我根据统计发现两个加油站的车流量在同一段时间内至少差三倍。这个时候我就开始明白，管理人是不是有拥有者的心态也很重要。通过这些事儿，我就开始慢慢地理解，一个公司怎么赚钱，为什么能比别的公司赚得多。像这个加油站的例子就是最典型的，完全同质的产品，一点差别都没有，但是服务上稍微超差了一点点，流量就能差三倍。那位印度人这样做的原因是什么？跟我一样因为他是移民，需要钱，如果他不能把顾客拉进来，他经济上肯定会有问题。另一边就没事，跟他也没什么关系，他就拿着工资，假装在工作。所以就是这一点差别。这个时候开始，我就对公司本身是怎么管理的，每个公司在竞争中的优势，哪些优势是可持续的，哪些优势不可持续等问题开始产生兴趣。所以后来我就在我能理解的一些小公司中找到了一两个特别有竞争优势的企业，并获得了很好的回报。再后来又从理解小公司变成了理解大公司，能力圈也跟着一点点变大。</span
          >
        </p>
        <!--274--><!--275--><!--276--><!--277--><!--278--><!--279-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我举这些例子想要说明的是，如果我自身的这些经验能有一些普遍的意义的话，如果你要建立自己的能力圈，你投资的东西必须是你真知道的东西。安全边际很重要，你只要对在安全边际内的那部分真懂，其它的你不懂不重要。这是第一点。</span
          >
        </p>
        <!--280--><!--281--><!--282--><!--283--><!--284--><!--285-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第二，一旦你开始用所有者的角度来看生意的时候，你对生意的感觉就完全不同了。如果说我不用真的去买，也能够用生意拥有者这个角度去看待当然是最理想的，但是从人的心理角度来说，做到这点很不容易。所以这种心理学的技巧（psychological
            trick）是有用的。我们都有敝帚自珍的心理，一旦说这是我的东西了，它哪都好！所以一旦你把自己视为拥有者的时候，你会瞬间充满了学习的动力。我让我公司的研究员去研究一家公司，第一件事就是要告诉他，假设你有一个从未谋面的叔叔，突然去世了，留了这家公司给你，这个公司百分之百属于你了，那么你应该怎么办？你要抱着这样的心态去做研究。当然做到这点和你实际拥有还是不太一样的。尤其是我刚开始做投资时，个人净资产是负值，所有的钱都是借来的，这给我带来的动力非常大。其实现在也是一样，我们和所有人谈话也都是抱着百分之百拥有公司的心理。我们去公司调研，和谁都得谈，碰到保安也得聊一聊，他的工作做得怎么样？他是不是雇得合理？我们人力资源的政策是怎么样的？所有的问题都会关心。</span
          >
        </p>
        <!--286--><!--287--><!--288--><!--289--><!--290--><!--291-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第三，知识是慢慢积累起来的，但是你必须一直抱有对知识的诚实（intellectual
            honesty）的态度。这个概念非常重要，因为人很难做到真正客观理性。人都是感情动物，我们相信的东西、对我们有利的东西，通常就会成为我们的预测。我们总是去预测这个世界对我们很好，而其实客观上我们都明白，这个世界不是为你存在和安排的。所以做到对知识的诚实很难但是非常重要。知识是一点点积累起来的，当你用正确的方法去做正确的事，你会发现知识的积累和经济的增长是一样的，都是复利的增长。过去学到的所有经验都能够互相印证、互相积累，慢慢地你会开始对某些事情确实有把握了。</span
          >
        </p>
        <!--292--><!--293--><!--294--><!--295--><!--296--><!--297-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >另外对我来说很重要的一点，就是一定要让你的兴趣和机会来主导研究，不要听到别人买了什么东西，我也跟风去研究。别人的股票和机会是别人的事，与你无关，你只要把自己的事情做好。如果你发现了机会，那就去研究这件事；如果你对某样东西有兴趣，就去研究它。这些机会、这些兴趣本身会带着你不断地往前走，一点一点去积累你的知识，不用着急。</span
          >
        </p>
        <!--298--><!--299--><!--300--><!--301--><!--302--><!--303-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >最后的结果是每个人的能力圈都不一样。每一个价值投资者的投资组合都不太一样，也不需要一样。你不需要跟别人多交流。你要投的东西也不会太多。因为每一件事情要想搞懂，都需要花很多很多时间，一支股票、一个公司也是如此。你最终建立起来的能力圈、能够大概率预测正确的公司一定很少，而且一定是在自己的能力范围内。如果它不在自己能力范围内，你也不会花时间去研究。所以你的能力圈必定是在小圈里。真正能赚钱，不在于你了解得多，而在于你了解的东西是正确的。如果你了解的东西是正确的，你一定不会亏钱。</span
          >
        </p>
        <!--304--><!--305--><!--306--><!--307--><!--308--><!--309-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">四、价值投资人的品性</span></p>
        <!--310--><!--311--><!--312--><!--313--><!--314--><!--315-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >下面一个问题，什么样的人适合做价值投资？价值投资人是不是有一些共通的、特殊的品性？沃伦和查理一直说，决定一个价值投资人能否成功的因素不是他的智商或者经历，最主要的是他的品性（temperament）。品性是什么呢？下面我来谈谈自己的理解。以我个人这么多年的经验，我也觉得，有些人不太适合做价值投资，有些人则天生更适合。</span
          >
        </p>
        <!--316--><!--317--><!--318--><!--319--><!--320--><!--321-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第一点，他要比较独立，看重自己内心的判断尺度，而不太倚重别人的尺度。比如说，有些人的幸福感需要建立在他人的评价上，自己买的包，如果得不到他人的赞美，就失去了意义。另外一些人就不一样，自己的包，只要自己喜欢，每天看着都高兴。独立的人往往不受别人评价的影响，这是种天生的性格。而独立这个品性对投资人特别重要，因为投资人每时每刻都面临着各种各样的诱惑，而且还因为比较产生嫉妒情绪。</span
          >
        </p>
        <!--322--><!--323--><!--324--><!--325--><!--326--><!--327-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第二点，这个人确实能够做到相对比较客观，受情绪的影响相对来说比较小。当然，每个人都是感情动物，不能完全摆脱感情的影响，但是确实有些人能够把追求客观理性作为价值观念、道德观念来实践。这样的人就比较适合做价值投资。投资实际上是客观地分析各种各样的问题，还要去判断很长时间以后的事情，这件事本身是很困难的。如果我们不是从公司资产负债表的角度来看，而是谈公司的盈利能力，那么竞争是最重要的。收益好的公司一定会吸引大批竞争者，竞争者会抢夺市场和利润，所以预测一个当前成功的公司在十年后能否保持高利润是很难的，即便公司的管理者也不见得能说得清，往往更为“当局者迷”。所以你必须要保持一个非常客观理性的态度，能够不断地去学习，这极其重要。</span
          >
        </p>
        <!--328--><!--329--><!--330--><!--331--><!--332--><!--333-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >下面一个品性也比较特殊，这个人既要极度地耐心，又要非常地果决，这是一个矛盾体。没有机会的时候，他可以很多很多年不出手，而一旦机会降临，又一下子变得非常果决，可以毫不犹豫地下重注。我跟芒格先生做投资合伙人十六七年了，我们每个礼拜至少共进一次晚餐，我对他了解蛮多。我这里可以讲一个他投资的故事。芒格先生订阅《巴伦周刊》（Barron’s），就是美国华尔街日报的一个跟股票市场有关的周刊。这个杂志他看了将近四五十年，当然，主要目的是去发现投资机会，那么在整个四五十年中，他发现了多少机会呢？一个！就只有一个，而且这个机会是在看了三十多年以后才发现的。那之后十年再也没发现第二个机会。但是这不影响他持续阅读，我知道他依然每期都看。他有极度的耐心，可以什么都不做，可是他真的发现这个机会的时候，他就敢于全部地下重注，而这个投资给他赚了很多。这是一个优秀投资人的必备品性：你要有极度的耐心，机会没来的时候就只是认真学习，但是机会到来的时候，又有强烈的果决心和行动能力。</span
          >
        </p>
        <!--334--><!--335--><!--336--><!--337--><!--338--><!--339-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第四点，就是芒格先生为什么可以连续四五十年这么做，就是他对于商业有极度强烈的兴趣。沃伦和查理总是讲商业头脑（money
            sense），商业头脑就是对生意的强烈兴趣，而且天生地喜欢琢磨：这个生意怎么赚的钱，为什么赚钱？将来竞争的状态是什么样的？将来还能不能赚钱？这些人总是想彻底弄明白这些问题，这个兴趣实际上是他最主要的动力。</span
          >
        </p>
        <!--340--><!--341--><!--342--><!--343--><!--344--><!--345-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这几个性格都不是特别的自然，但是这些性格合在一起，却可以让你成为一个非常优秀的投资人。这些品性中有一些是天生的，有些是后天的，比如说对商业的兴趣其实是可以慢慢培养出来的。但是有些品性，比如说极其的独立，比如极度的耐心和极度的果断，则未必能后天培养出来。一般的人30多年看个东西，什么也没发现，绝大多数人早就不看了。而发现了这一个机会之后，就总想马上再发现一个。但是芒格先生没有，我因为跟他很近，所以观察得很清楚，他的性格确实如此。独立这一点也不是特别容易做到，因为绝大部分人会受到社会评价的影响，会关注别人的看法，这样的人在价值投资的道路上很难坚持下去。</span
          >
        </p>
        <!--346--><!--347--><!--348--><!--349--><!--350--><!--351-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >相比之下，智商和学历真的不太重要。如果智商和学历重要的话，那牛顿就是股神了。实际上，牛顿在泡沫最热的时期把全部积蓄投资在南海公司的股票，几乎是倾家荡产。所以即使你觉得自己比牛顿还要天才，其实也没用。你绝对不需要这么高的智商，不需要那么聪明，更不需要有天才，反正我是肯定没牛顿聪明。投资行业真的不需要特别高的智商，不需要太多显赫的学历和经历。我看过太多的聪明的、高学历、经历丰富的投资人，结果却很不成功，动不动就被投机吸引过去了。当然他们可以说自己是用基本面分析方法加上对市场的了解等等，反正说起来都一套一套的。人越聪明，就越说得天花乱坠，结果就越糟糕。你不需要科班出身，也不需要念MBA，但是你要对商业有强烈的兴趣。如果你本身对商业没有强烈的兴趣，就算上了MBA也不一定能培养出来。</span
          >
        </p>
        <!--352--><!--353--><!--354--><!--355--><!--356--><!--357-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我有个投资做得非常好的朋友跟我说投资和打高尔夫球很像，我很同意。你必须得保持平常心，你的心绪稍稍一激动，肯定就打差了。前一杆跟后一杆没有一点关系，每一杆都是独立的，前面你打了一个小鸟球（birdie；注：高尔夫球术语，比标准杆低一杆，是非常好的成绩），下一杆也不一定能打好。而且每一杆都要想好风险和回报。一个洞的好坏胜负并不会决定全局，直到你退役之前，都不是结果。而你留在身后的记录就是你一生最真实的成绩，时间越长，越不容易。所以多打打高尔夫球，对于培养投资人的品性有帮助。冥想（meditation）也很有好处，它能够帮助你对自己的盲点认得更清楚一些。又比如打桥牌可以培养你的耐心等等。有一些东西可以帮助你提升这方面的修养，尤其是我说的这些品性里后天的成分。跟高尔夫球一样，有的东西你一段时间不练习、不实践，确实会忘记。一旦脱离了商业，你的敏锐度（sharpness）确实是会慢慢消失的。</span
          >
        </p>
        <!--358--><!--359--><!--360--><!--361--><!--362--><!--363-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >如果有些人说我的确不具备这些品性，该怎么办呢？我的建议是不要强迫自己去做不擅长的事。你可以去找有这些品性的、擅长的人去帮你。人总是需要找到自己比较擅长又喜欢的事情来做，这样自己才能做得高兴、充满动力，因为不是为别人而做。</span
          >
        </p>
        <!--364--><!--365--><!--366--><!--367--><!--368--><!--369-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">五、普通人如何保护并增加自己的财富</span></p>
        <!--370--><!--371--><!--372--><!--373--><!--374--><!--375-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >下面我们来谈谈一个普通的投资人，他可能不想做一个专业的投资人，也可能没有机缘，那他如何能够保护自己的财产，让财产慢慢地增加？</span
          >
        </p>
        <!--376--><!--377--><!--378--><!--379--><!--380--><!--381-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第一，别忘了你的备选（alternative）就是现金。现金也可以是基本面研究分析的结果。当你没有发现更好的机会成本的时候，现金是个不错的选择，肯定比你乱花钱去投机强。</span
          >
        </p>
        <!--382--><!--383--><!--384--><!--385--><!--386--><!--387-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >第二，如果一个市场的股权能够大致反映经济的整体状况，那么指数投资还是很有用的。如果经济本身以2-3%左右的速率实际增长，加上通货膨胀，也就是4-5%左右的名义增长，那么经济体里的规模以上公司的平均利润会再稍高一些，比如说有6-7%的增长。我们前面讲到，如果以这样的速率增长200多年，就是百万倍的回报，即使是在你的有生之年，30年、40年的过程中，也会给你带来相当不错的回报。所以你不要去相信那些动不动就说每年百分之几十回报率、翻倍收益的人，这多数大都是些投机的人。投资这件事一定要靠谱。什么事情是靠谱的？可持续的事。如果不可持续，就不用听了。所以指数投资在指数能够大致反应整个经济体平均表现的情况下，是一种不错的选择。</span
          >
        </p>
        <!--388--><!--389--><!--390--><!--391--><!--392--><!--393-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >如果你能够找到优秀的投资人当然最好，但是找到优秀的投资人不是特别容易，尤其在国内现在的环境里。我们其实很想在国内建一个像Graham
            and
            Doddsville那样的价值投资的小村落，有些原住民住在里面，大家愿意把自己比较真实的回报率，以及如何得到这样的回报率拿出来分享，看看有没有长期的结果。现在有很多投资人，动不动把他管理的基金叫“产品”。我很难理解这种说法，感觉是工厂里生产出来的一样，而且动辄几十个，好像没有一两百个产品都不能叫成功的投资人，但最后你根本搞不清他的投资结果是什么。我23年来就管理一只基金，我的钱基本都投在里面，这样相对来说就比较好判断投资结果。你如果能够找到值得托付的投资人，而且是实实在在地用正确方法做事的，这当然是非常好的选择。</span
          >
        </p>
        <!--394--><!--395--><!--396--><!--397--><!--398--><!--399-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >一般来说，选择投资人首先一定要看清楚他是不是一个投机者。第二，他要具备一定的投资人的品性。第三，他对于自己的专业有一定深度的了解，而且有一个相对较长的投资回报表现记录。接下来，你要看他选择的能力圈是不是在一个竞争激烈的圈子里，如果他的能力圈刚好处在一个竞争不太激烈的范围之内，就更有可能获得比较好的回报。还有你要看他的收费方式是不是合理的、双赢的，他的利益和投资人有没有大的冲突。最后一点是这个人年龄还不算太高，还能在相当长的时间里让你的财富复利地增长。如果你能够找到满足所有这些条件的投资人，可以说是非常幸运了。</span
          >
        </p>
        <!--400--><!--401--><!--402--><!--403--><!--404--><!--405-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是总的来说，个人投资者最忌讳的就是被市场诱惑，像牛顿那样，在市场非常炙热的时候进去，又在市场低迷的时候出来。不去参与投机是最基本的原则，只要你做到这点，而且只去投资你懂的东西，不懂的东西不做，基本上不会亏钱。有些人立志自己去做投资也很好，但是因为个人投资者时间相对比较有限，所以投资必须要比较集中，一定要投资你确实特别了解的少数几只股票。这个集中度很重要。因为个人投资者的时间、精力、经验等都是集中在很少的几个范围之内，所以在这些范围之内你就只能是集中，必须要集中。通过长期的努力个人投资者也可以做到这种程度。但是最忌讳的是去交信息剥削税。你去看一看基金管理人的收费机制，如果不是双赢（win-win）收费机制的就不要考虑了，凡是只对管理人有好处的，肯定有问题。</span
          >
        </p>
        <!--406--><!--407--><!--408--><!--409--><!--410--><!--411-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以，如果你了解这几个基本原则，就可以保护好你的财富，也可以让你的财富慢慢地增长。只要是以复利的方式、正确的方式增长，那么即使是慢慢的增长，在长期内的回报也是很可观的。绝大部分人对复利没有信念，是因为复利这个现象在生活中并不常见。比如说，最有可能复利增长的是各种经验、智慧，但因为绝大部分人的学习方法有问题，所以他们的知识无法积累，而且常常老化，因此他们连最基本的知识复利现象也看不到，很难去想象复利的力量有多大。如果你对投资有兴趣，那你一定要理解复利的魔力，爱因斯坦称它为世界第八奇迹是绝对有道理的。你越明白复利的力量，越明白获得复利有多难，那么当你得到复利增长的机会的时候，虽然它看起来不那么高大上，比如说百分之六、七、八、九这样的机会，你也一定要明白，这是你一生最重要的机会，一定要抓住。只要复利的时间足够长，这就是你人生最好的、最重要的机会。以上几点就是我对于普通人的建议。</span
          >
        </p>
        <!--412--><!--413--><!--414--><!--415--><!--416--><!--417-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">六、价值投资与人生</span></p>
        <!--418--><!--419--><!--420--><!--421--><!--422--><!--423-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >最后我们总结一下价值投资。价值投资是不是一种信仰？我觉得可能是，因为它确实体现了一种价值观——你不愿意去剥削别人，也不愿意玩零和游戏，只愿意在自己挣钱的同时，也对社会有益。你不愿意去做一个完全靠赌博挣钱的人，所以下次当你看到投机的人时，你不用跟他说“祝你好运（Good
            luck）！”，因为他不可能一直都好运，你应该说“玩得开心点儿（Have a
            good
            time）！”大家到赌场去玩，其实就是去买高兴，你花了钱都不能玩得开心，那这钱就白花了。很多人回来之后情绪非常低落、抑郁，那就白去了，更怕的是变成赌徒了，最后输得一穷二白。如果你只是当作去赌场玩一下，这是可以的。但是如果你的价值观念不是赌徒的价值观念，那你就要在股票市场上远离赌博，不懂的东西绝对不做。懂的事情就是你能够在相当长的时间里，以极高的概率预测正确的事情。如果不能满足这个条件，你宁可不碰。所以从这个角度来说，价值投资确实体现了一种价值观念，可以说是一种信仰。</span
          >
        </p>
        <!--424--><!--425--><!--426--><!--427--><!--428--><!--429-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >如果是一个信仰，就必须要得到验证，过程中你还得经历一下绝望的考验，所以你的感情一定会上下起伏，至少在刚开始时是这样。但是慢慢地，你会真正把它变成自己人生的一部分，波澜起伏逐渐变成了荣辱不惊。由你强烈的对生意本身的兴趣带领，慢慢建立起属于自己的能力圈，然后在自己的能力圈之内游刃有余，之后你就可以心无旁骛，远离其他杂音的干扰。所以我发现真正成功的投资人，大多数都离金融中心比较远，而且离得越远，业绩越好，比如说奥马哈。其实和北京、上海，纽约、香港这些金融中心的人交流少一些可能更有帮助。那些听起来“高大上”的交易理论说法其实都是杂音。为什么叫杂音呢，因为投机最终的净结果是零。如果对我今天的分享你只记住一件事的话，只要记住这个零和概念——投机的净结果都是零。虽然大家不提，但事实就是这样，这是一个很简单的数学概念。你记住了这一点，下次再碰到那些“高大上”的说法，你就可以把他们当作市场先生。你会发现，格雷厄姆对于市场先生的形容其实还是很贴切的。</span
          >
        </p>
        <!--430--><!--431--><!--432--><!--433--><!--434--><!--435-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >最后我想说，学习价值投资的整个过程对我个人来说其实特别有意思。最开始为了生计，我误打误撞、机缘巧合地闯进这个行业，进入后发现真的是别有洞天，这个行业确实有很多不可思议的事情，让你时刻都在学习新鲜的事情，感受到你的见识、判断力真正是复合性地在增长。所以你不仅能体会到你的资产回报复合性的增长，还能够体会到自己的能力、学识、见识，都以复利的方式增长。在投资这个行业中，你能同时看到两种现实生活中不常见的复利增长现象，这是非常有意思的事。</span
          >
        </p>
        <!--436--><!--437--><!--438--><!--439--><!--440--><!--441-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我年轻的时候一直在追寻人生的意义，后来我渐渐悟到其实人生真正的意义就是追求真知。因为真正的真知可以改变生活，改变命运，甚至可以改变世界。而且人和其它我们能观察到的事物、和客观世界完全不同。我们观察到的物质世界基本上是一个熵增的世界，能量从高处往低处流动，大的总是能够吃掉小的，体积大的星球撞击体积小的星球必然能将其压碎，整个地球、宇宙到一定程度也会走向湮灭。但是人类世界不同，人可以把世界变成一个熵减的世界，可以让熵倒流。人可以通过学习，从完全无知变得博学；人可以通过修身养性，成为一个道德高尚的人，对社会有贡献的人；人还可以创造出这么多以前根本无法想象的新事物。自从人类来到地球，整个世界、地球都发生了巨变，今天我们甚至有可能离开地球移民太空，可以让宇宙都发生变化，这些完全是有可能的。前面提到，我做的第一个投资和无线电话有关，虽然当时我也没完全搞清楚。26年后的今天，我们谁还能够离开手机？手机、互联网，所有这些其实都只是一个小小的真知就创造出来的巨大的变化。互联网其实就是TCP/IP，就是一个协议（protocol）。整个计算机就是一个零和一的排列组合，再加上用硅和电来决定是零还是一的二极管---就这么一个真知让整个世界发生了翻天覆地的变化。</span
          >
        </p>
        <!--442--><!--443--><!--444--><!--445--><!--446--><!--447-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以对我来说，投资的经历让我真实感受到了人的熵减过程。投资，尤其是在正道上的价值投资，其实就是一个人的熵减的旅程。在这个过程中，你确实可以帮助着去创造，你确实可以做到“多赢”，你不仅帮助了自己，也帮助了身边的人。而且这些被你所支持的洞见，能够让人类世界变得和其他生物所在的客观世界完全不一样。我觉得这是一件特别美妙的事，我想把这种感觉也分享给大家。希望我们能够在价值投资的路上，可以一起走得很远。谢谢大家！</span
          >
        </p>
        <!--448--><!--449--><!--450--><!--451--><!--452--><!--453-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >2019年11月29日北京大学光华管理学院演讲- 问答部分</span
          >
        </p>
        <!--454--><!--455--><!--456--><!--457--><!--458--><!--459-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >1.
            问：作为从事了十多年行业分析的卖方分析师，在转型价值投资的路上，有哪些挑战？该怎么切入？已经是一个老司机了，怎么样换频道？</span
          >
        </p>
        <!--460--><!--461--><!--462--><!--463--><!--464--><!--465-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：卖方、买方实际上就是心理的一个变化。为什么我会有公司所有者的心理，是因为我买了第一只股票以后，就发现这个公司真的是我的。人的心理就是这样，对自己拥有的东西感觉就会不同。卖方的情况也是一样的，如果我老想着要把股票卖出去，因为公司给我的激励机制就是要我卖出去，那么我总要把我的这头猪打扮得漂亮一点儿，甚至可以把它说成麒麟。当然也可能你卖的正好就是特别好的东西，比如你负责研究茅台，确实本身也是很好的企业，但是你从心理上首先想把它卖出去。从人的心理上来说，确实基本上屁股和脑袋是很一致的，这一点很难改变。因为你如果不这样的话，你就太别扭了，在任何地方都待不下去。所以当你从卖方过渡到买方的时候，比如我发现我以前很多做投行的朋友去做投资，基本上都不太成功，因为他还保持着原先做投行的心理，最主要是要把主意卖给别人，因为卖得太好了，所以把自己也说服了。人都是这样，所以说别骗自己，因为自己最好骗。你把“卖给别人”做得特别好的时候，常常就把东西卖给自己了，这个是一定的。所以我就说客观理性特别重要。</span
          >
        </p>
        <!--466--><!--467--><!--468--><!--469--><!--470--><!--471-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >如何客观理性？你需要把自己的位置调换一下。所以我觉得你在正式转型之前，最好是先做一些个人投资，感受一下这两者在心理上的差别。做了一些个人投资之后，你会真的感觉到这个公司是我的了。你的想法和卖方的想法就开始发生很大的变化，你去收集信息的方式也不一样，相当于你接受信息的天线开始转向。当你的天线发生转向的时候，你会发现收集到的信息也不一样了。</span
          >
        </p>
        <!--472--><!--473--><!--474--><!--475--><!--476--><!--477-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以我认为第一步需要在心理上做调节。最好的办法是你先自己来做一做，在正式加入价值投资的行列之前要自己做些投资，但是要用价值投资的方法，而不是用卖方的方法。卖方的方法就是“我想卖的东西永远都是最好的”。你如果没有这个想法，也很难做好卖方。所以你碰到一个卖保险的，看到谁都想把他发展成下家，看着谁都像下家，为什么？靠着这个他才成功，这没办法！所以最重要的第一步是要在心理上做调节，当你感觉到心理发生变化的时候，就会开始脱离原先做卖方的思维给你的枷锁。</span
          >
        </p>
        <!--478--><!--479--><!--480--><!--481--><!--482--><!--483-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是原来你对商业的了解、对公司的了解仍然是可用的、可积累的。而当你用所有者的天线去重新梳理信息的时候，会发现很多信息的频道发生变化了，信息发生变化了，你的知识还有用，但是你组织知识的思维结构会发生一些很微妙的变化，而这些变化特别重要。你要不走完这一步很难直接转到买方。</span
          >
        </p>
        <!--484--><!--485--><!--486--><!--487--><!--488--><!--489-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >2.
            问：研究错误能让人理解成功。您是否见过立志做价值投资的年轻人，尤其是具备您所说的品性这样的人，但是最后没有坚持下去而失败的？如果您见过这样的人，他们为什么失败？</span
          >
        </p>
        <!--490--><!--491--><!--492--><!--493--><!--494--><!--495-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：我见过很多不同的人，也有各种各样失败的原因，最主要的原因还是兴趣。一个人最终能够坚持把一件事情做好，这件事必须要符合他的兴趣。最容易成功的方向其实就是你既有兴趣又有能力的方向。比如说有些人，可能他有价值投资的品性，但是他对别的事情更有兴趣。学习了一段时间价值投资后，他又被别的东西吸引过去了，这是完全可以的，而且我认为这是一个合理的决策。我认为，最重要的不是哪一个行业能赚更多的钱。如果抱着这个念头，你就会去跳来跳去，因为总是有人比你赚的钱更多。你要是用赚钱多少来做判断，你生活得一定很悲惨。所以最终还是要跟随自己的兴趣。如果你的兴趣在价值投资，只要你走在这条路上了，一般来说会越走越远，越走越长。但是如果兴趣不在此，我看到的最多的例子确实是兴趣不在此。但是他在价值投资中学到的东西在别处都会有用，前提是他的品性要比较适合价值投资。</span
          >
        </p>
        <!--496--><!--497--><!--498--><!--499--><!--500--><!--501-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >3.
            问：怎么确定自己对于研究的公司懂和不懂？自己觉得懂和事实上真的懂，有没有一个客观判断的原则标准？</span
          >
        </p>
        <!--502--><!--503--><!--504--><!--505--><!--506--><!--507-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：因为我们做的是预测，所以懂和不懂其实就看你预测得对不对。但是对不对这个谜底不是马上揭开的，都要很多年以后才揭开。如果你是对知识诚实的人，你会一直坚持去揭晓这个谜底，所以你自然会知道你是真懂还是不懂。我对自己公司员工的标准是，如果你对一个公司的研究达到懂的状态，你要能看得出10年以后它最坏的情况是什么样。最好的情况常常会自然发生，所以你要明白它10年之后最坏会到怎样的情况。如果我做不到这一点，我就不太能说自己懂这个公司。但是我的预测结果发生的概率要很高，在非常高的概率下我是正确的，而且我还要跟它10年去看一看我的预测对不对。</span
          >
        </p>
        <!--508--><!--509--><!--510--><!--511--><!--512--><!--513-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以这确实是一个比较难的问题。最难的地方在哪里？在于人有很多天生的心理倾向。芒格先生在我们翻译的《穷查理宝典》中专门列出了25种人天生的心理倾向，可能实际情况中比这个数字还要多。这些心理倾向之所以存在，是因为我们人类的大脑基本上是自然选择、设计的结果。自然选择的大脑其最主要的功能是让我们能够产生更多的后代，能够生存下去。但是我们今天的生活状态实际上是一个文化进化的结果。我们已经生活在高度文明的社会里面，文化进化的社会中很多规则和生物进化不太一样，所以我们身上的那些先天的心理倾向有很多硬伤，让我们不能够非常客观、理性地去做判断。这就是为什么我们在学习和研究中确实会遇到这位同学提的问题，他觉得都懂了，但是他其实并没有明白自己身上的盲点，而没有明白自己身上的盲点导致的结果是他最终被证明是错误的，他其实确实不太懂。</span
          >
        </p>
        <!--514--><!--515--><!--516--><!--517--><!--518--><!--519-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以当你觉得你明白一件事情的时候，你首先要知道你不明白什么事，因为我们明白的事情肯定是有限的。能力圈最重要的概念就是能力圈有边界，它是一个圈。你如果不知道这个圈的边界在哪里，说我都明白了，那你肯定就不明白。你还要明白，当你知道一个事情是正确的时候，一定要知道它什么时候会错才行。芒格先生有一个标准，我觉得还蛮有用的。他说如果我想拥有一个观点，我必须得比我能够找到的最聪明的、反对这种观点的人还能反驳这个观点，只有在这种情况下我才配拥有这个观点。我觉得这是一个不错的标准。你可以用这个标准来判断自己懂还是不懂，你可以反过来想，能不能找到我认识的最聪明的人，把我所谓懂的东西驳倒，然后我发现他的思维还不如我，我比他驳得还厉害。这个时候有可能，也不能说完全，你确实是理解了。</span
          >
        </p>
        <!--520--><!--521--><!--522--><!--523--><!--524--><!--525-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是你必须得知道你的这个理解在什么时候是错误的，换句话说，你必须要知道你的这个能力确实是在一个圈里。你如果不明白你能力圈的边界在哪里，你实际上就不明白，因为你不可能都明白。这么说有点抽象，但是一旦到具体问题的时候就很实在了。我们公司有几位同事坐在这里，他们每个人都经历过我问的问题。我的问题一定会把你推到边界上去，你不被推到边界上不可能真的理解。这就要靠知识的诚实，要不断去训练，一下子很难做到。大家如果不是用这种思维方式来生活，确实不太容易做到真懂。这种习惯对一个人一生都特别有帮助。</span
          >
        </p>
        <!--526--><!--527--><!--528--><!--529--><!--530--><!--531-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >4.
            问：您刚才讲了怎么样做到真懂。您前面也提到价值投资是学习的过程。能否请您分享一下用什么样的学习方法，才能感受到知识复利的增长？</span
          >
        </p>
        <!--532--><!--533--><!--534--><!--535--><!--536--><!--537-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：有用的知识要具备这么几个基本条件。首先它可以被证实，它的逻辑和你看到的事实都能够支持它，再者它确实能够用来解释一些事情，有很强的解释力，同时它还要有比较有用的预测能力。所以我们看到现实生活中的知识里最有用的、最符合这些标准的知识就是科学知识。科学知识的确满足了上面说的所有标准。但是我们现实生活中遇到的现象大多数没有科学理论的依据，因为我们碰到的事情多多少少跟人有关，而跟人有关的事情多多少少是一个几率的分布。我们学习数学，微积分其实不是太重要，但是统计学一定要学好。因为现实中遇到的几乎所有的问题都是统计学的问题。我们再回到这个问题，研究现实生活中这些问题用什么学习方法呢？你还是要用科学的方法，但你必须要知道你得到的是模糊的结果。你宁愿要模糊的正确，也不愿意要精确的错误。你要用科学的方法去学习，这仍然是最有效、最能够积累知识的方法。</span
          >
        </p>
        <!--538--><!--539--><!--540--><!--541--><!--542--><!--543-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >另外对我而言最有用的方法是让自己的兴趣做引导。当你对一件事情有强烈兴趣的时候，你能在比较短的时间内、比所有人都有效率的情况下积累起这方面的知识，而且做得比所有人都更好。因为你最终使用这些知识的时候，还是会在一个竞争的环境里；你对于一个事情的判断，还是要拿来跟别人的判断进行比较的。当你对一个事情有强烈的兴趣的时候，别人停止学习的时候你可能还在想，别人已经满足的时候你可能还在问，这就会让你获得最重要的优势（edge）。所以让自己的兴趣来引导，用科学的方法、用诚实的态度缓慢地、一点一滴地去积累知识，仍然是我看到的唯一可靠的学习方法。</span
          >
        </p>
        <!--544--><!--545--><!--546--><!--547--><!--548--><!--549-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >5.
            问：我们周围有两类比较成功的投资者，一类是判断大局，判断企业的大格局，相信优秀、诚信的管理者，把企业交给管理层来管理，自己做甩手掌柜，这是一类成功的投资者，另一类是希望自己比管理层还懂企业的生意，事无巨细都希望了解。请问您对这两个风格的评价是什么？</span
          >
        </p>
        <!--550--><!--551--><!--552--><!--553--><!--554--><!--555-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：这两类风格其实都是获得知识的一部分。对企业来说，其管理人的水平的确是一个很大的变量。一个企业在长期发展中，时间越长，尤其是还在初创时期中、处于一个高速发展的环境下，创始人和企业主要管理者确实对公司的价值会起到非常重要的作用。但是企业的很多特点又是由行业本身的竞争格局形成的，并不由个人的意志为转移。一个人不管有多大能力，在一个非常差的环境里其实也做不出多么优秀的结果；一个相对资质没那么高的人，在一个特别好的行业里面，也可以做得非常优秀。比如有很多优秀的国企，其实它们的领导压根就没干过企业，这也不影响它们的业绩表现很好。每一个企业具体的情况是不一样的，具体情况要具体分析。但是标准都是一样的，就是你获得的知识最终还是要能够用来比较准确地、大概率地预测未来很多年以后的情况。无论你用什么样的方法、从什么样的角度、从哪一个方面，其实各个方面你都要覆盖。你要了解一个企业，必须要了解它的管理层，也必须要了解它的行业基本规则。所有这些都是价值投资相对来说不那么容易的原因，你要了解的东西很多很多。</span
          >
        </p>
        <!--556--><!--557--><!--558--><!--559--><!--560--><!--561-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以这就是我们为什么要有一个安全边际的概念。今天我对安全边际的概念讲得相对比较少。我们使用安全边际最主要的原因是因为我们对未来的预测是有限的，我们的知识是有限的。如果你有足够的安全边际、足够的价格保护，这会让你在不太懂的情况下也能赚很多钱。为什么我刚才讲课时举了那个例子？它的生意用今天的标准来看我真的一点都不懂，真是撞了狗屎运，赚了好几倍钱，其实我应该赚一倍的钱。但就是因为有安全边际，所以我敢去投。然后在投完之后，进而又学习到了很多东西。所以说安全边际特别的重要，当你对未来的预期不太清楚的时候，一定要去选择那些特别便宜的机会。你在选择不同机会的时候，便宜仍然是硬道理。</span
          >
        </p>
        <!--562--><!--563--><!--564--><!--565--><!--566--><!--567-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >6.
            问：请您给大家介绍一下企业的哪些特点要素是企业护城河的主要来源？是品牌、管理团队，还是它的商业模式？您最看重的几类护城河是什么？</span
          >
        </p>
        <!--568--><!--569--><!--570--><!--571--><!--572--><!--573-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：这要看时间有多长。时间越长，这个行业本身的特性是护城河最有效的保护；时间越短，人的因素越重要。</span
          >
        </p>
        <!--574--><!--575--><!--576--><!--577--><!--578--><!--579-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >每一个行业、每一个企业的竞争优势的来源都不太一样，可保护的程度也不太一样。虽然我们要求的最终理解的标准一样，分析的方法一样，但实际上你花了很多时间去研究后最终得到的答案是，绝大部分企业其实是说不清楚的，也没法预测。很多企业本身的变化确实不构成持续的竞争力。比如我们举最简单的例子——餐馆，在任何时候，每过一段时间总有一批餐馆在北京是生意最好的，某一个菜系是生意最好的。但是你会发现没过多久又变了。因为即便它现在很好，很难保证它将来还会很好。像这类企业，你可以花很多时间去了解，但是最终你会发现，其实你很难判断。</span
          >
        </p>
        <!--580--><!--581--><!--582--><!--583--><!--584--><!--585-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以我觉得至少对我个人而言，我会把时间都花在那些在我看来更能够预测的行业里，然后在这些行业里边再去找找看，哪些企业它可预测不仅仅是因为它所在的行业本身可预测，而且也因为它自身确实优秀——优秀的含义就是它对资本的回报远高于它的竞争者。然后我在这些企业中再去发现有哪些东西其实我还是蛮有兴趣的，可能我还有一定的能力去研究，或者已经在我的能力圈范围之内。这些经过精挑细选后的企业才是我应该去花时间去研究的。全球上市的企业大概有10万家左右，但是你在任何时候其实不需要研究超过5到10家公司，所以你第一个最重要的工作是做减法。很多东西你可以忽略不计，很多东西都不在你的能力范围之内。你做的唯一重要的事情是确保如果一个机会是在你的能力范围之内、属于你的机会，你一定不能搞错！但是不属于你的机会，你完全可以忽略。</span
          >
        </p>
        <!--586--><!--587--><!--588--><!--589--><!--590--><!--591-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以我还是回到原来说的，要做自己相对来说比较了解的，然后也可以在选择上比较挑剔。因为你一旦了解了一个公司之后，你可以慢慢地等待，当机会来的时候，当价格开始进入到相对于你认为的价值有足够的安全边际的时候——这时即使你错，你也不可能亏钱——在这个时候你可以大规模地下重注。所以这样看来，你的研究最好集中在你能够真的弄透、弄明白的事情上。而且既然你选得很少，不妨就选择最优秀的。当然你也可以选最小的、可以抓得住的，也可以去选价格已经很便宜，如果能够理解透、安全边际足够高，不可能会亏钱的。总之你投的是确定性，你要回避的是不确定性。当价格可以给你提供确定性，那价格就成了最重要的考量；当你自己的知识圈、你的能力、判断力成为你的确定性的时候，最好你研究的是本身特别优秀的企业，这样你就不需要不断地每过几年更换标的，你就可以持续很久很久，让这个公司本身的复利增长来为你工作。</span
          >
        </p>
        <!--592--><!--593--><!--594--><!--595--><!--596--><!--597-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >7.
            问：通过你的讲座，我们对价值投资人具有哪些特点，包括性格特点有了一定的了解。您看中的企业家，他们的最主要的特点是什么？</span
          >
        </p>
        <!--598--><!--599--><!--600--><!--601--><!--602--><!--603-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：我从事广义的商业大概有二十六七年了，也见过形形色色、各种各样非常成功的企业家或是不太成功的企业家。我发现市场经济有一个特别有意思的特点，它可以释放各种各样的人的潜能。很多成功的企业家在日常生活中，其实都有这样那样的“问题”。他们在市场经济中被发现之前，在生活中你可能都不太愿意跟他们打交道，而且他们如果从事别的行业可能大概率会失败。但是市场经济就能让任何特殊的人、不同的人、社会“异类”都有可能在他最终选择的细分行业（niche）里成功。</span
          >
        </p>
        <!--604--><!--605--><!--606--><!--607--><!--608--><!--609-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >所以我从不去判断具有哪些典型特征（prototype）、哪些标准人格的人可以在市场经济中成为优秀的企业家。市场经济恰恰就能让各种各样有特色的人都有可能创造出一个适合他的企业，然后取得很大的成功。所以我的结论是没有一个统一的标准说具备什么样素质的人就一定会成功。</span
          >
        </p>
        <!--610--><!--611--><!--612--><!--613--><!--614--><!--615-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是具体到每一家公司，而不是仅仅分析人的时候，你可以去研究分析，你会了解到为什么这个人创造了这样的一家公司，而且这家公司非常成功。马云自己可能不管公司经营中那些很细节的东西，但他很明白怎么去管人，怎么去用人，他用的人对经营的细节非常敏感，张勇就是这样的人。所以说每一个人都会找到特别适合自己的企业，在判断一个企业的时候，千万不要轻易地下结论说因为这个人怎么样，这个企业一定会成功或者不成功。我也遇到很多看起来各方面条件都应该是对的人，结果他的企业做得很一般。大家可能也都有类似的经验，看一看身边的人，有些人非常优秀，看起来最有可能成功，但后来也不见得做得很好，这种情况比比皆是。所以我觉得一定要回到每一个企业本身，要具体情况具体分析。</span
          >
        </p>
        <!--616--><!--617--><!--618--><!--619--><!--620--><!--621-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >8.
            问：对于一个学生而言，毕业以后如果要从事投资工作的话，是不是应该去一个投资机构作为第一步？是不是需要一个师傅带着做投资？</span
          >
        </p>
        <!--622--><!--623--><!--624--><!--625--><!--626--><!--627-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：以前我在哥大上学的时候，也上过这样一门价值投资课。当时哥大是唯一开设这堂课的大学，沃伦每年都会去讲一次课，也总有人会问他这个问题。他说，最好的学习方法是给你最尊敬的人去工作，这样你会学得特别快。听完这个答案之后，我就决定自己开公司了。（听众笑）其实是开玩笑的啊，主要是因为我找不着工作。</span
          >
        </p>
        <!--628--><!--629--><!--630--><!--631--><!--632--><!--633-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我觉得人跟人也不太一样，有些人确实是在别人的指导下会学得更快一些。但是问题是实践中价值投资人特别少，所以这样的公司自然也很少，而且这些公司基本上不怎么需要雇人——如果这个公司非常成功的话。比如沃伦的公司里，下属100多家分公司，雇了50多万员工，但是他的公司总部一共只有25个人，一直到七八年前，投资人就只有两个，他和芒格两个人管5000多亿美金。所以也很难到他那儿去工作。好不容易在七八年前雇了两个年轻人，他也不带他们，让他们自己去管。我们公司也是，也就十几个人。所以如果有去价值投资人的公司工作的机会当然好，但是那样的机会很少，尤其是特别优秀的投资人基本上不怎么需要雇人。（听众笑）这是一个悖论。</span
          >
        </p>
        <!--634--><!--635--><!--636--><!--637--><!--638--><!--639-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这也是为什么我们要开这门课的原因，而且将来我们也想建一个中国的价值投资人村，有这么一批人，能够有比较长期的、独立的结果，不是那种发几百个产品的投资人，就一只基金，一个管理人，一种风格，持续很多年得出的结果，这就是我们说的“白名单”结果。我们应该去找这样的人。然后大家真心地看到这个结果是可能的，实实在在的。如果我当年没看到巴菲特真人，我对股票的理解还停留在像曹禺在《日出》里描写的那样，我是断然不会进入这个行业的。当然我也想给巴菲特工作，但他不雇人。我们也不雇人。所以我觉得最好的办法还是自学，自学的同时去和已经在这条路上走了很远的人有一些交流还是非常有用的。</span
          >
        </p>
        <!--640--><!--641--><!--642--><!--643--><!--644--><!--645-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我基本上不做演讲，但唯一的例外就是我常常会回我的母校哥大，对那门价值投资课上的学生做一些分享。在北大开设这堂课之前我也没有在中国做过演讲，今天是我第二次在中国做演讲。为什么不做演讲？其实也是和投资有关系，跟人本身的倾向有关系。回到刚才卖方和买方的问题，人本身天然有卖的倾向——大家总想把自己打扮得比实际更漂亮一些，要不然我们买这些衣服干嘛呀？总想显得比自己实际的结果更有知识、更有判断力、更厉害。夸大自己是人的心理倾向，很难改变。所以你每次去讲的时候都在强化这种观念，尤其是讲一些具体的股票的时候，你每次去讲，每次见投资人的时候，本来还留了一些比较健康的怀疑，因为人不可能百分之百确定，能有百分之八、九十的确定性就很不错了。但你会把它说成百分之百确定，讲多了就变成百分之二百、三百了，到最后把自己都给骗了，自己都坚信不疑了。你讲得越多，结果一定会更烂。所以我基本上从来不去讲，但是唯一在什么时候讲呢？就是这种场合下，跟同学们去分享一下，因为确实这样的机会很难得。我不讲具体的公司，但是可以分享一些经验。</span
          >
        </p>
        <!--646--><!--647--><!--648--><!--649--><!--650--><!--651-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >总而言之，第一选择仍然是给你尊敬的人去工作。第二选择就是能够自学，而且在自学过程中能够找到你比较敬佩的人，尽量和他保持一定的关系，包括上今天这样的课——今天有很多朋友从全国各地飞来，好像还有从美国飞过来的——其实是有用的，如果我处在你的位置上，我也会这么做。这一点点的分享在实践中会特别有用，因为价值投资就是一门实践的学问。而且投资本身是一个孤独的过程，是自己做决定的事，讨论的人一多，变成一个委员会，你的客观性就丢掉了，你就无法判断成功几率（odds）了，团队的趋同性（group
            dynamic）也会发生作用，影响你的判断——人的心理倾向对投资而言是很可怕的障碍。我们的生物进化出来的大脑不太适合做投资这件事，所以你确实需要一个修炼的过程。如果大家有这样的机会，那当然一定要珍惜这个机会，抓住这个机会；但是没有机会的时候，你可以创造其他的机会，当然最主要的还是自己学习，自己体验这样一个过程。</span
          >
        </p>
        <!--652--><!--653--><!--654--><!--655--><!--656--><!--657-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >9.
            问：我很想买一个便宜的股票去研究它，学得更多。但是在这之前我还是想问一下，基于资产负债表的研究到底能给我提供多少安全边际？</span
          >
        </p>
        <!--658--><!--659--><!--660--><!--661--><!--662--><!--663-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：我觉得你急于买一个股票去研究，还是急于想研究一个股票，然后再买，顺序不要搞错，要研究好了再投。（听众笑）我觉得你的问题可能是上哪去找那些从资产负债表上看市净率那么低的股票？确实在今天的市场中，这样的股票可能不太多了，但其实这样的机会在亚洲很多市场都还存在。我假设你在全球都可以投，全球大概有10万只股票每天都在交易，在亚洲还有很多股票你可以去研究、了解，这样的股票仍然存在。比如说公司是在营利状态，可能未来很多年都是营利状态，资产是你可以验证的，比如说是股票、证券或者房地产，是你可以看到的，减掉所有的负债，得到的净资产比如说是100，而公司正好在50左右的价格交易，这样的机会虽然跟我开始的时候相比已经少了很多，但是还有！很奇怪，在任何时候，市场总有这些犄角旮旯的地方有这样的机会。如果我要重新开始，什么都不懂，我可能还是会从这里开始，因为这方面我比较有把握，能够看得见、摸得着，即便我对公司其他方面都不懂，我也不会亏钱。但是在今天的市场里，在我们现在管理的资金规模下，我就不能研究这个问题了。所以在这方面我肯定不是最好的专家。很抱歉我真的无法给你一个满意的答案。但是我知道在其他的市场还有这样的机会，至于在中国市场有没有，我就真不知道了，抱歉啊！</span
          >
        </p>
        <!--664--><!--665--><!--666--><!--667--><!--668--><!--669-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >10.
            问：请您介绍一下芒格先生什么样的经历、特点造就了他的投资理念？芒格先生的投资理念，据您的了解，是怎么形成的？</span
          >
        </p>
        <!--670--><!--671--><!--672--><!--673--><!--674--><!--675-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：首先芒格先生的很多观念，在从事投资之前就已经根深蒂固地形成了，比如他对于了解这个世界是怎么运转的具有特别根本的兴趣，他特别想弄明白这个世界是怎么运转的，而且对于通过实践去弄明白也特别有兴趣。他就是想弄清楚这个世界什么行得通，什么行不通，尽一切可能去避免行不通的事情。这些观念和投资没什么关系，就是从很小的时候形成的兴趣。现在想想，我也是一样，我在第一次听到沃伦演讲之前，有一些基本的观念已经存在，比如，我对投机有一种生理上的厌恶，我一点都不喜欢。所以我听了他的演讲之后，尽管后来遇到了很多很多华尔街各式各样的投资流派，各式各样的风云人物，各式各样成功的人，但是我从来就没什么兴趣。沃伦也说过，价值投资就像打疫苗一样，打完以后，要么管用，要么不管用，沃伦很少看到过（我也没有看到过），一个一开始就投机的人，然后突然之间有一天他醒悟了，转而想做价值投资去了，这种情况几乎没有发生过。反正我一个这样的例子都没看到过。所以有些观念，那些能够让芒格先生成功的观念，其实在他做投资之前早就形成了，然后他这些观念也影响了沃伦。因为芒格先生对于什么行得通很有兴趣，他自然地会对非常强的、优秀的公司有兴趣，因为这些公司的方法行得通，这些公司赚钱能力比那些便宜的公司好多了。</span
          >
        </p>
        <!--676--><!--677--><!--678--><!--679--><!--680--><!--681-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >沃伦早期在格雷厄姆那边干了两年多，跟着他学习了两年左右。格雷厄姆看待问题的方式也强烈影响地影响了他。因为格雷厄姆的理论主要形成在大危机时代，他在二十年代初期，1929年之前也做了一些投资，也有些是投机，而且做得蛮失败的。1929年之后，他痛定思痛，开始系统性地总结一套不同的方法，后来做得不错。而且他从事的时间，主要跨越了从1929年到50年代。1929年股市下跌之后，什么时候才恢复的呢？一直要到50年代初，中间差不多过了17年的时间。所以格雷厄姆大部分职业生涯就涵盖了美国股市最绝望的时候，指数天天在跌，就跟我们A股一样。他是在这种情况下取得了优秀的成就，可是他也不可能做得很大。这些公司，沃伦说的“捡烟屁股的公司”，没有办法做大。</span
          >
        </p>
        <!--682--><!--683--><!--684--><!--685--><!--686--><!--687-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >这些想法让他在这个时期很成功，当然对沃伦的影响也很强大。但是当沃伦自己开始做的时候，是50年代中期和末期，这个时候的美国经济，已经从大危机中走出来了，整体经济情况开始上升，那些优秀的企业也真正开始发挥威力了。所以这个时候，芒格先生对沃伦的影响就特别的有意义，他从一开始，就对格雷厄姆的这一套理论有相对的保留，对他而言更多地是想弄清楚这个世界是怎么运转的，什么行得通，什么行不通，然后去重复行得通的方法，避免行不通的方法。他对于优秀的公司特别有兴趣，而且他不强调这些公司非要有很大的折让才能去买，因为这些优秀的公司本身就是一个折让，本身就会不断超越别人的预期。后来这个想法慢慢地对沃伦产生了巨大的影响。所以在沃伦的成熟期间，他就慢慢摆脱了大危机的影响，生存的方法，但是他仍然保留了很强的对于估值、对于安全边际的要求。这个是我观察到的沃伦身上非常根深蒂固的想法。我想我个人也是这样，可能跟我个人的经历有关。每个人的风格也不太一样。</span
          >
        </p>
        <!--688--><!--689--><!--690--><!--691--><!--692--><!--693-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >11.
            问：您刚才提到对一般的普通投资人来说，投资指数基金可能是在一个比较健康的经济下比较好的投资方式，假设现在这种被动的指数基金大规模进场的话，您认为它对于整个股票市场的负面影响是什么？</span
          >
        </p>
        <!--694--><!--695--><!--696--><!--697--><!--698--><!--699-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：这是一个很有意思的问题。这在中国倒不是一个很大的问题，因为指数基金占的比例很小。在中国和在美国这是两个不同的问题。在中国，因为我们现在还没有完全实行注册制，我们也没有很强的退市政策，所以我们的股指不太能够完全地、公平地反映经济本身的状况。这个问题，我觉得是监管部门可能在下面若干年要着力解决的问题。我们从以制造业、出口为主的经济形态进入到以消费为主的经济形态。以消费为主，融资的方法就要从间接金融变成直接金融，股票市场的作用会越来越大，这就需要吸引更多的人进入股市。需要更多的人进入，就需要控制赌博的成分、泡沫的成分，增加投资的成分。而增加投资的成分最好、最快、规模最大的办法还是股指投资，所以要让股指比较能够公平地反映经济本身的情况。一方面，可能的替代方案是，研究出比较好的ETF（交易型开放式指数基金），能够比较公平地代表经济的现状。但这里面人为的因素比较多，不是特别容易做好。所以最好的办法还是用市场来解决，比较快地让市场进入到注册制的状态，把退市先做起来，入市也逐渐地做好，这样股指就变得比较有代表性了。这是中国的问题。</span
          >
        </p>
        <!--700--><!--701--><!--702--><!--703--><!--704--><!--705-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >美国的问题是指数投资占比越来越高，高到什么程度时，它开始会有一种自身带的正循环和负循环影响到定价？市场之所以需要投资人，是因为投资人是真正能够给证券定价的人。如果市场缺乏定价的机制，就会对整个融资造成扭曲。被动投资最大的问题就是不做定价。需要什么比例的投资人在市场里，才能够让市场比较有效？这是现在成熟市场面临的问题。美国今天股指的大概比例，还没有完全高到影响定价的程度。但是这样发展下去，到一定程度的时候，确实有这种可能性，会让定价的投资人越来越少，以至于失去定价的功能。这是大家的一个说法，但是我个人不是那么担心。因为在股指出现之前，股市中一直有一大堆的投机者，价值投资人更少。我在这里把价值投资人和基本面投资人分开来看，价值投资人其实是基本面投资人中间比较挑剔的一类人，这些人要求的安全边际比较高，但是这些人的思维方式是一样的。这些人，根据我的感觉，一直在市场上占得比例不大。以前哥伦比亚法学院有一位教授叫路易斯·鲁文斯坦（Louis
            Lowenstein），他做过一个比较系统的统计，到底市场中价值投资人估算应该有多少。当时他算出来大概在5%左右，这不是一个很科学的算法，但是我也没有看到其他人在这个方面做更多的工作。但是不管是5%也好，还是7%、4%或者10%，总之这个比例不太高。在股指投资出现之前，一直是这些人作为市场定价最中坚的力量，但是并没有发生大规模的失效，当然泡沫一直都在。除了到了2008-2009年的时候，确实到了一个很极端的情况，所以我总是觉得这个问题可能还要到很多年以后，才会成为股票市场一个比较大的问题。</span
          >
        </p>
        <!--706--><!--707--><!--708--><!--709--><!--710--><!--711-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >但是这个问题在中国不存在，中国的问题是，今天的股指不足以比较公平地代表整体的经济状况，而且还没有一个替代的ETF。谁能够把一个替代的ETF发展出来，能够比较公平地代表经济的状况，这对普通大众投资人就是一个很大的贡献。这方面，监管层需要做很多的工作。</span
          >
        </p>
        <!--712--><!--713--><!--714--><!--715--><!--716--><!--717-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >12.
            问：请从价值投资角度分享您关于健康、关于家庭和关于人生的思考。</span
          >
        </p>
        <!--718--><!--719--><!--720--><!--721--><!--722--><!--723-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >李录：这方面思考还挺多的，好像我也不是最佳的回答人。我离过一次婚，这个婚不是我愿意离的，这方面我不能算是人生赢家。但是我和前妻一直保持挺好的关系，现在她的钱也还是我管着。（听众笑）所以我不能说是这方面的专家，大家跟着我学就麻烦了。</span
          >
        </p>
        <!--724--><!--725--><!--726--><!--727--><!--728--><!--729-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我觉得投资是一个很长期的事情，短期的业绩其实一点用都没有。沃伦之所以让大家敬佩，是因为他真的是有将近六十年的业绩。取得长期的业绩特别重要，而你要取得长期的业绩，身体首先得好。沃伦和查理他们俩，一个89岁，一个96岁，还每天都工作，热情不减。所以我觉得第一个特别重要的事是长寿，想要长寿其实最主要的还是要干自己喜欢干的事。保持良好的生活习惯固然很重要，但更重要的是干自己喜欢干的事儿，而且要有颗平常心。你看沃伦和查理他们从来就不会焦虑，因为他们所有的做法都是多赢，所以也就没有压力。比如说，他们两个人50年前的工资就是一人10万美金。50年之后，现在还是一人10万美金。他要是去收取1%的管理费，现在5000亿的资产规模你们可以算算1%是多少？他如果收取20%的业绩提成（Performance
            fee），那他的资产有多少？但是这样一来，他就必须每年都面对业绩的压力，一旦有人要撤资，他就有压力，而且如果他收了别人的管理费、表现费，他必须就要值这个收费，当然他就不会这么随心所欲了。现在他有1000多亿现金，但他不需要有压力，也没有压力。所以他把自己的生活安排好，他就住在奥马哈，你到那儿去，他有可能去见一下你，你要不去的话，他每天就干自己的事，吃同样的东西，“跳着踢踏舞去上班”，所以他才可以有一个很长的业绩。还有，他对人的所有关系都是做到双赢，他对人是真心地特别好。我们认识这么多年，他是真心地对所有人好，真心地愿意帮助别人，他对任何人都没有任何恶意。不是说他没有判断，他也有不喜欢的人，但是他躲开就是了。他把自己的生活安排得非常平常、非常可持续，这一点也特别重要。所以说，有一个好家庭，有一个被爱来环绕的环境，非常重要。</span
          >
        </p>
        <!--730--><!--731--><!--732--><!--733--><!--734--><!--735-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >你和同事之间、朋友之间等等，与人为善非常重要，没有恶意非常重要。你无论做什么事，都要采取多赢的方式。你看我们从来也不收管理费，而且我们前百分之六的回报也都是免费的。所以如果你取得指数基金的回报，在我们管理的基金这里你一分钱都不用付，在这之上你赚得的钱，超过指数投资的部分，大家都希望你能赚得更多。这点我们也是从巴菲特那里学来的，这就叫巴菲特公式（Buffett
            formula），是他早期的收费结构。这让我们生活得很平常，我可以到这里来和大家分享，我也没什么压力，这个也很重要。我们同事之间大家互相都很友爱，我们都非常的公开，没有任何敌意，我们跟所有人的关系都是共赢关系。</span
          >
        </p>
        <!--736--><!--737--><!--738--><!--739--><!--740--><!--741-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >而且我们从来不去强迫自己。你真懂的东西才做，不懂的东西绝对不做，所以做的时候一定会很坦然，市场的上上下下一定不会影响你的情绪。只有在这种情况下，你才会拥有一个比较长的业绩。所以平常心就特别的重要，你把你的生活、你和其他人的关系变成共赢，变成以爱为根基，就变得特别重要。常常地去奉献也很重要，常常去帮助别人，确实是会让每个人心情非常的好，生活也很幸福。沃伦对幸福的定义是：People
            who I want to love me actually love
            me（我想要爱我的人是真心爱着我），这就是他的定义，我觉得他这个定义很不错。用这种方法来组织生活，会让你在很长的时间里和别人都是一个共赢的关系，而且你会在没有压力的情况下，看着自己的知识和能力不断地累进增长，然后看着这些知识又能够让你管理的资金慢慢地累进增长，让那些委托你的投资人能够有更多的财富来帮助别人。我们只给大学捐赠基金和慈善基金，还有那些用于慈善的家族的钱提供管理服务，基本上不是为了“让富人变得更富”去管钱——我们选客户很挑剔。这样我就觉得我们是在为社会做贡献。你如果用这种方式来去组织人生的话，你会做得很坦然，也不着急，会在自己的步调上慢慢地去生活。</span
          >
        </p>
        <!--742--><!--743--><!--744--><!--745--><!--746--><!--747-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >很多投资人跟我说，我们也想按照你的方式去投资，可是问题是我的投资人不干，他老是想下一个小时咱们挣多少钱呀，上一个小时已经都赚了或者亏了。我觉得这样的人就不该是你的投资人。他说如果这些人不是我的投资人，我就没有投资人了，我怎么能够去找到像你的投资人那样的呀？我开始的时候也没有投资人，就是我自己借得那点儿钱，我那个时候净资产还是负数。芒格有一句话，他说你怎么去找到好的太太呢？第一步你得让自己配得上你的太太，因为好的太太肯定不是个傻子。所以说投资人也是一样的。我们基金开始的时候，很多年就一直是我自己的钱，再加上几个客串的朋友，比较相信你，但是也无所谓，然后慢慢地你做得时间长了、业绩好了，那些合适的人自然会来找你，你在他们中间再挑选更合适你的人。你这样慢慢地去做起来，不需要很快，也不需要跟别人比。所以最重要的就是平常心，你要相信复利的力量，相信慢慢地去进步的力量。复利的力量就是慢慢的，7%的增长，在200年里增长了75万倍，这个是不低的，对吧？这就是复利的力量啊。</span
          >
        </p>
        <!--748--><!--749--><!--750--><!--751--><!--752--><!--753-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们40年前改革开放刚开始的时候，谁能想到中国会变成今天这个样子，在这个过程中其实它平均就是9%的增长，好像听起来也不太高，可是短短的40年——在座还是有些人在40年前已经出生了对吧？（听众笑）我们完全可以用“天翻地覆”来形容这40年来中国的变化！所以一定要相信复利的力量。不要着急，也没必要跟别人斗，没必要跟别人比。相互合适的人慢慢都会找到彼此。找不到的时候也不用急。如果有耐心，有这颗平常心，慢慢地去做，也会做得反而更好。为什么要跟打高尔夫类比呢，打高尔夫就是心绪一急，球马上就打坏掉了，情绪一变化，结果马上就变。如果有颗平常心，你就会越做越好。</span
          >
        </p>
        <!--754--><!--755--><!--756--><!--757--><!--758--><!--759-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >节制生活，锻炼身体，用双赢、用黄金法则（The Golden
            Rule）来组织自己的生活，不要强迫自己，去做自己喜欢做的事情。这些听起来都是常识，但是你在年轻的时候这些常识不太容易真正做到。因为大家着急，特别是年轻的时候。为什么着急？因为老是跟别人比，过去的同学谁谁谁还不如我呢，现在怎么样怎么样了。这是他的生活，跟你有什么关系呢？每个人都得活自己的一辈子，而且这一辈子其实很短，年轻时候觉得日子很慢，到了我这岁数，这日子就飞快啊，一年转眼就过去了。所以这辈子你必须得活自己的生活，你只有活自己的生活，你才能活出幸福来。而且只有过自己的生活，你才能真正地进步。不怕慢，“慢就是快”，这是段永平先生最喜欢讲的，我觉得他讲得很对。</span
          >
        </p>
        <!--760--><!--761--><!--762--><!--763--><!--764--><!--765-->
      </div>
      <!--13--><!--766--><!--767-->
      <p class="free">（来源：点拾投资）</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>